












































































import VueOptions from '@utils/VueOptions'

settings =
  name: 'PayoutBankAccountResourceListItem'

  vue:
    props: ['item', 'rowSize', 'actions', 'selected', 'backgroundColor']

    computed:
      isActiveClass: ->
        switch @item.is_active_name?.toLowerCase()
          when 'active'   then 'bg-green text-white'
          when 'inactive' then 'bg-red-lightest text-red'
          else 'bg-grey-dark text-white'

      bankAccountStatusClass: ->
        switch @item.bank_account_status_name?.toLowerCase()
          when 'linked'     then 'bg-green text-white'
          when 'not linked' then 'bg-red-lightest text-red'
          else 'bg-grey-dark text-white'

export default VueOptions.vue settings
